import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { ReservationFamily } from './reservation-family.model';
import { ReservationFamilyPopupService } from './reservation-family-popup.service';
import { ReservationFamilyService } from './reservation-family.service';
import { CRUD_ACTIONS } from '../../shared/index';

@Component({
    selector: 'jhi-reservation-family-delete-dialog',
    templateUrl: './reservation-family-delete-dialog.component.html'
})
export class ReservationFamilyDeleteDialogComponent {

    reservationFamily: ReservationFamily;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private reservationFamilyService: ReservationFamilyService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {}

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.reservationFamilyService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'reservationFamilyListModification',
                content: {
                    action: CRUD_ACTIONS.DELETE,
                    content: {id: id}
                }
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-reservation-family-delete-popup',
    template: ''
})
export class ReservationFamilyDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private reservationFamilyPopupService: ReservationFamilyPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.reservationFamilyPopupService
                .open(ReservationFamilyDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/reservation-family-delete-dialog.component.ts